import React, { Component } from "react";
import { Paper, Avatar } from "material-ui";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  avatar: {
    color: "#ffffff",
    backgroundColor: "#16845b"
  }
});

class GridItem extends Component {
  handleClick = () => {
    const { product, onSelect } = this.props;

    if (onSelect) {
      onSelect(product);
    }
  };

  render() {
    const { classes, product } = this.props;

    if (!product) {
      return null;
    }

    const initials = (product.name || "")
      .split(" ")
      .slice(0, 2)
      .map(word => word.charAt(0))
      .join("")
      .toUpperCase();

    const image =
      product.images &&
      product.images.length > 0 &&
      product.images[0] &&
      (product.images[0].src || product.images[0].url);

    const stock = product.stockQuantity;
    const hasStock = stock == null || Number(stock) > 0;

    const lowStock =
      stock != null &&
      Number(stock) > 0 &&
      Number(stock) <= 5;

    return (
      <Paper
        onClick={this.handleClick}
        elevation={0}
        style={{
          minHeight: 270,
          padding: 12,
          boxSizing: "border-box",
          cursor: hasStock ? "pointer" : "not-allowed",
          borderRadius: 18,
          border: "1px solid #e2ebe7",
          background: "#ffffff",
          boxShadow: "0 5px 18px rgba(24, 61, 50, 0.06)",
          transition:
            "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          opacity: hasStock ? 1 : 0.65
        }}
        onMouseEnter={event => {
          if (!hasStock) {
            return;
          }

          event.currentTarget.style.transform = "translateY(-4px)";
          event.currentTarget.style.boxShadow =
            "0 12px 28px rgba(24, 61, 50, 0.13)";
          event.currentTarget.style.borderColor = "#b9d9cc";
        }}
        onMouseLeave={event => {
          event.currentTarget.style.transform = "translateY(0)";
          event.currentTarget.style.boxShadow =
            "0 5px 18px rgba(24, 61, 50, 0.06)";
          event.currentTarget.style.borderColor = "#e2ebe7";
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10
          }}
        >
          <span
            style={{
              fontSize: 9,
              fontWeight: 800,
              letterSpacing: "0.4px",
              color: !hasStock
                ? "#b91c1c"
                : lowStock
                  ? "#b45309"
                  : "#16845b",
              background: !hasStock
                ? "#fef2f2"
                : lowStock
                  ? "#fff7ed"
                  : "#edf8f3",
              borderRadius: 999,
              padding: "5px 8px"
            }}
          >
            {!hasStock
              ? "OUT OF STOCK"
              : lowStock
                ? "LOW STOCK"
                : "IN STOCK"}
          </span>

          <span
            style={{
              fontSize: 9,
              color: "#8a9993",
              fontWeight: 600
            }}
          >
            #{product.id}
          </span>
        </div>

        <div
          style={{
            width: "100%",
            height: 120,
            borderRadius: 14,
            background: "#f5f8f7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            border: "1px solid #edf2ef"
          }}
        >
          {image ? (
            <img
              src={image}
              alt={product.name || "Product"}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block"
              }}
            />
          ) : (
            <Avatar
              className={classes.avatar}
              style={{
                width: 58,
                height: 58,
                fontSize: 17,
                fontWeight: 700,
                boxShadow: "0 5px 14px rgba(22, 132, 91, 0.20)"
              }}
            >
              {initials}
            </Avatar>
          )}
        </div>

        <div
          style={{
            width: "100%",
            marginTop: 10,
            flex: 1
          }}
        >
          <div
            style={{
              fontSize: 13,
              fontWeight: 700,
              color: "#19352d",
              lineHeight: "18px",
              minHeight: 36,
              maxHeight: 36,
              overflow: "hidden"
            }}
          >
            {product.name}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: 7
            }}
          >
            <div
              style={{
                fontSize: 17,
                fontWeight: 800,
                color: "#16845b"
              }}
            >
              {"\u20A6"}{Number(product.price || 0).toLocaleString()}
            </div>

            <div
              style={{
                fontSize: 10,
                color: "#71817b",
                fontWeight: 600
              }}
            >
              {stock == null ? "Stock N/A" : `${stock} left`}
            </div>
          </div>
        </div>

        <div
          style={{
            width: "100%",
            marginTop: 11,
            padding: "10px 0",
            borderRadius: 11,
            background: hasStock ? "#16845b" : "#d7dfdc",
            color: hasStock ? "#ffffff" : "#71817b",
            textAlign: "center",
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: "0.2px",
            boxShadow: hasStock
              ? "0 5px 12px rgba(22, 132, 91, 0.18)"
              : "none"
          }}
        >
          {hasStock ? "+ Add to Cart" : "Out of Stock"}
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles, { withTheme: true })(GridItem);
